import { toast } from "react-hot-toast";


export const downloadTemplate = async (fileName = 'Template.xlsx', downloadName = 'Template.xlsx') => {
  try {
    const response = await fetch(`/${fileName}`);
    
    if (!response.ok) {
      throw new Error('File not found');
    }
    
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = downloadName;
    document.body.appendChild(link);
    link.click();
    
    // Cleanup
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    toast.success("Template downloaded successfully!");
  } catch (error) {
    console.error('Error downloading template:', error);
    toast.error('Failed to download template. Please try again.');
  }
};

/**
 * Opens the user guide documentation in a new tab
 */
export const openUserGuide = () => {
  window.open(
    "https://document-store-ui.cloud-effem.com/documentations/TOOL_DOCUMENTATION-DRAFT-DATAPULSE_PLAYBOOK/",
    "_blank"
  );
};

